webpackJsonp([35783957827783],{

/***/ 644:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.query = undefined;
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _gatsbyLink = __webpack_require__(33);
	
	var _gatsbyLink2 = _interopRequireDefault(_gatsbyLink);
	
	var _semanticUiReact = __webpack_require__(35);
	
	var _productcard = __webpack_require__(86);
	
	var _productcard2 = _interopRequireDefault(_productcard);
	
	var _productfilters = __webpack_require__(106);
	
	var _productfilters2 = _interopRequireDefault(_productfilters);
	
	var _reactHelmet = __webpack_require__(41);
	
	var _reactHelmet2 = _interopRequireDefault(_reactHelmet);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var IndexPage = function IndexPage(_ref) {
	  var _ref2;
	
	  var data = _ref.data;
	  return _react2.default.createElement(
	    'div',
	    { style: { maxWidth: 1260, margin: '0 auto' } },
	    _react2.default.createElement(
	      _reactHelmet2.default,
	      null,
	      _react2.default.createElement(
	        'title',
	        null,
	        'Find Growth Tools | The Best SaaS Tools To Help Startups Grow'
	      ),
	      _react2.default.createElement('meta', {
	        name: 'description',
	        content: 'A curated list of the best SaaS tools to help your company grow. Discover growth tools by category, growth lever, integration and more.'
	      }),
	      _react2.default.createElement('meta', {
	        property: 'og:image',
	        content: 'https://images.ctfassets.net/wmadclbhjs1z/2JSsQivOtuWeORWiNBKKzg/005487471f4b465c1b3bca7d657e67a4/opengraph.png'
	      }),
	      _react2.default.createElement('meta', { name: 'twitter:card', content: 'summary_large_image' }),
	      _react2.default.createElement('meta', { name: 'twitter:site', content: '@findgrowthtools' }),
	      _react2.default.createElement('meta', {
	        name: 'twitter:title',
	        content: 'Find Growth Tools | The Best SaaS Tools To Help Startups Grow'
	      }),
	      _react2.default.createElement('meta', {
	        name: 'twitter:image',
	        content: 'https://images.ctfassets.net/wmadclbhjs1z/2JSsQivOtuWeORWiNBKKzg/005487471f4b465c1b3bca7d657e67a4/opengraph.png'
	      })
	    ),
	    _react2.default.createElement(
	      _semanticUiReact.Responsive,
	      { minWidth: 770 },
	      _react2.default.createElement(
	        _semanticUiReact.Segment,
	        { basic: true },
	        _react2.default.createElement(
	          _semanticUiReact.Grid,
	          { columns: 2 },
	          _react2.default.createElement(
	            _semanticUiReact.Grid.Column,
	            { textAlign: 'center' },
	            _react2.default.createElement(
	              _semanticUiReact.Segment,
	              { basic: true },
	              _react2.default.createElement(
	                'h1',
	                {
	                  style: {
	                    fontSize: '3.25rem',
	                    color: 'white'
	                  }
	                },
	                'Find the best',
	                ' ',
	                _react2.default.createElement(
	                  'span',
	                  {
	                    style: {
	                      color: '#39e7ce',
	                      // fontFamily: 'OpenSans-ExtraBold',
	                      fontFamily: 'Open Sans',
	                      fontWeight: '800',
	                      letterSpacing: '-1.5px'
	                    }
	                  },
	                  'SaaS tools'
	                ),
	                ' ',
	                'to help your company grow.'
	              )
	            )
	          ),
	          _react2.default.createElement(
	            _semanticUiReact.Grid.Column,
	            { verticalAlign: 'middle' },
	            _react2.default.createElement(
	              _semanticUiReact.Segment,
	              {
	                basic: true,
	                compact: true,
	                textAlign: 'center',
	                style: { maxWidth: 1260, margin: '0 auto' }
	              },
	              _react2.default.createElement(
	                'h3',
	                { style: { color: '#FFF' } },
	                'Find growth tools by'
	              ),
	              _react2.default.createElement(
	                'div',
	                null,
	                _react2.default.createElement(
	                  _semanticUiReact.Button,
	                  {
	                    style: { marginBottom: '10px' },
	                    compact: true,
	                    size: 'small',
	                    href: '/categories/'
	                  },
	                  'Category'
	                ),
	                _react2.default.createElement(
	                  _semanticUiReact.Button,
	                  {
	                    style: { marginBottom: '10px' },
	                    compact: true,
	                    size: 'small',
	                    href: '/growthlevers/'
	                  },
	                  'Growth Lever'
	                ),
	                _react2.default.createElement(
	                  _semanticUiReact.Button,
	                  {
	                    style: { marginBottom: '10px' },
	                    compact: true,
	                    size: 'small',
	                    href: '/integrations/'
	                  },
	                  'Integration'
	                ),
	                _react2.default.createElement(
	                  _semanticUiReact.Button,
	                  {
	                    style: { marginBottom: '10px' },
	                    compact: true,
	                    size: 'small',
	                    href: '/customers/'
	                  },
	                  'Customer'
	                )
	              )
	            )
	          )
	        )
	      )
	    ),
	    _react2.default.createElement(
	      _semanticUiReact.Responsive,
	      { maxWidth: 769 },
	      _react2.default.createElement(
	        _semanticUiReact.Segment,
	        { basic: true },
	        _react2.default.createElement(
	          _semanticUiReact.Grid,
	          null,
	          _react2.default.createElement(
	            _semanticUiReact.Grid.Column,
	            { textAlign: 'center' },
	            _react2.default.createElement(
	              _semanticUiReact.Segment,
	              { basic: true },
	              _react2.default.createElement(
	                'h1',
	                {
	                  style: {
	                    fontSize: '1.5rem',
	                    color: 'white'
	                  }
	                },
	                'Find the best ',
	                _react2.default.createElement(
	                  'span',
	                  { style: (_ref2 = { color: '#39e7ce' }, _ref2['color'] = '#39e7ce', _ref2.fontFamily = 'Open Sans', _ref2.fontWeight = '800', _ref2.letterSpacing = '-1.5px', _ref2) },
	                  'SaaS tools'
	                ),
	                ' ',
	                'to help your company grow.'
	              )
	            ),
	            _react2.default.createElement(
	              _semanticUiReact.Segment,
	              {
	                basic: true,
	                compact: true,
	                textAlign: 'center',
	                style: { maxWidth: 1260, margin: '0 auto' }
	              },
	              _react2.default.createElement(
	                'h3',
	                { style: { color: '#FFF' } },
	                'Find growth tools by'
	              ),
	              _react2.default.createElement(
	                'div',
	                null,
	                _react2.default.createElement(
	                  _semanticUiReact.Button,
	                  {
	                    style: { marginBottom: '10px' },
	                    compact: true,
	                    size: 'small',
	                    href: '/categories/'
	                  },
	                  'Category'
	                ),
	                _react2.default.createElement(
	                  _semanticUiReact.Button,
	                  {
	                    style: { marginBottom: '10px' },
	                    compact: true,
	                    size: 'small',
	                    href: '/growthlevers/'
	                  },
	                  'Growth Lever'
	                ),
	                _react2.default.createElement(
	                  _semanticUiReact.Button,
	                  {
	                    style: { marginBottom: '10px' },
	                    compact: true,
	                    size: 'small',
	                    href: '/integrations/'
	                  },
	                  'Integration'
	                ),
	                _react2.default.createElement(
	                  _semanticUiReact.Button,
	                  {
	                    style: { marginBottom: '10px' },
	                    compact: true,
	                    size: 'small',
	                    href: '/customers/'
	                  },
	                  'Customer'
	                )
	              )
	            )
	          )
	        )
	      )
	    ),
	    _react2.default.createElement('br', null),
	    _react2.default.createElement('br', null),
	    _react2.default.createElement(
	      _semanticUiReact.Grid,
	      { textAlign: 'center' },
	      data.allContentfulProduct.edges.map(function (_ref3) {
	        var node = _ref3.node;
	        return _react2.default.createElement(
	          'div',
	          { key: node.id },
	          _react2.default.createElement(_productcard2.default, { key: node.id, node: node }),
	          _react2.default.createElement(_semanticUiReact.Divider, { hidden: true })
	        );
	      })
	    ),
	    _react2.default.createElement(
	      _semanticUiReact.Segment,
	      {
	        basic: true,
	        compact: true,
	        textAlign: 'center',
	        style: { maxWidth: 1260, margin: '0 auto' }
	      },
	      _react2.default.createElement(
	        'h4',
	        null,
	        'Still looking? Narrow your search:'
	      ),
	      _react2.default.createElement(
	        _semanticUiReact.Button,
	        {
	          style: { marginBottom: '10px' },
	          compact: true,
	          size: 'small',
	          href: '/categories/'
	        },
	        'Category'
	      ),
	      _react2.default.createElement(
	        _semanticUiReact.Button,
	        {
	          style: { marginBottom: '10px' },
	          compact: true,
	          size: 'small',
	          href: '/growthlevers/'
	        },
	        'Growth Lever'
	      ),
	      _react2.default.createElement(
	        _semanticUiReact.Button,
	        {
	          style: { marginBottom: '10px' },
	          compact: true,
	          size: 'small',
	          href: '/integrations/'
	        },
	        'Integration'
	      ),
	      _react2.default.createElement(
	        _semanticUiReact.Button,
	        {
	          style: { marginBottom: '10px' },
	          compact: true,
	          size: 'small',
	          href: '/customers/'
	        },
	        'Customer'
	      )
	    ),
	    _react2.default.createElement(_semanticUiReact.Divider, { size: 'large', hidden: true }),
	    _react2.default.createElement(_semanticUiReact.Divider, { hidden: true })
	  );
	};
	
	exports.default = IndexPage;
	var query = exports.query = '** extracted graphql fragment **';

/***/ })

});


// WEBPACK FOOTER //
// component---src-pages-index-js-8f38abb0d4f1ad0aac48.js